import { useStore } from 'Stores/index'

import { CountriesDE } from 'Constants/CountriesDE'
import { CountriesEN } from 'Constants/CountriesEN'
import { CountriesFR } from 'Constants/CountriesFR'
import { SupportedLanguagesEnum } from 'Constants/locale'

const getCountryList = (countries: { [k: string]: string }) => countries

/**
 * This hook is used to get country list for DHL shipping label modal.
 * Please wrap component with the `observer` method from 'react-mobx' for the hook to re-sync data properly.
 */
export const useShippingLabelCountryList = () => {
  const { portalSettingsStore } = useStore()
  const {
    i18n: { language: activeLanguage },
  } = portalSettingsStore

  switch (activeLanguage) {
    case SupportedLanguagesEnum.DE:
      return getCountryList(CountriesDE)
    case SupportedLanguagesEnum.FR:
      return getCountryList(CountriesFR)
    default:
      return getCountryList(CountriesEN)
  }
}
